import React from 'react';

import { OverallProductRating } from '../OverallProductRating/OverallProductRating';
import * as styles from './ProductRatingMaxiSummary.styles';

interface ProductRatingMaxiSummaryProps {
  averageRating: number | null;
  numberOfReviews: number;
}

export const ProductRatingMaxiSummary = ({
  averageRating,
  numberOfReviews,
}: ProductRatingMaxiSummaryProps) => {
  const heading = `${numberOfReviews} Product review${numberOfReviews === 1 ? '' : 's'}`;
  const rating = averageRating ? averageRating : 0;

  return (
    <div css={styles.overallRatingContainer}>
      <h2 css={styles.heading}>{heading}</h2>
      <OverallProductRating alignment="center" rating={rating} />
    </div>
  );
};
